import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { List, Flex, Header, Divider, Segment } from 'nallian-shared-ui/lib/components';
import { mapTemplateToReadableInfo } from '../helpers/mapTemplateToReadableInfo';

const TemplateInfo = ({ template }) => {
  const { t } = useTranslation();

  const { apps, communityRoles } = useMemo(() => mapTemplateToReadableInfo(template), [template]);

  if (!apps?.length && !communityRoles?.length) {
    return <Flex>{t('templateHasNoConfiguration')}</Flex>;
  }

  return (
    <Flex fluid direction="column">
      <p>{t('addTemplateInfo')}:</p>
      <Segment secondary>
        <Flex fluid margin="0 0 -0.5rem">
          <Header as="h4">{t('apps_plural')}</Header>
        </Flex>
        <Divider />
        <List>
          {apps.map(app => (
            <List.Item key={app.id}>
              <List.Content>
                <List.Header>{app.name}</List.Header>
                <List.List>
                  {(app.features || []).map(feature => (
                    <List.Item key={feature.id}>
                      <List.Content>
                        <Flex margin="0 0 0 1rem">
                          {t('feature')}: {feature.name}
                        </Flex>
                        <List.List margin="0 0 0 2rem">
                          <Flex margin="0 0 0 2rem">
                            {t('roles')}:&nbsp;{feature.roles?.map(r => r.name).join(', ')}
                          </Flex>
                        </List.List>
                      </List.Content>
                    </List.Item>
                  ))}
                </List.List>
              </List.Content>
            </List.Item>
          ))}
        </List>
        <Flex fluid margin="0 0 -0.5rem">
          <Header as="h4">{t('communityRoles_plural')}</Header>
        </Flex>
        <Divider />
        <List>
          {communityRoles.map(cr => (
            <List.Item key={cr}>
              <List.Content>
                <List.Header>{cr}</List.Header>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </Segment>
    </Flex>
  );
};

TemplateInfo.propTypes = { template: PropTypes.object.isRequired };

export default TemplateInfo;
